import {
  CompetitionData,
  CompetitionFeeApplicable,
  CompetitionMatch,
  PlainScoreCard,
  PlayerData,
} from 'src/data/mygolf.data';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Sanitizer,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { JsonService } from 'src/json-util';
import { Subscription } from 'rxjs';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { MessageDisplayUtil } from 'src/message-display-utils';
import * as global from 'globals';
import { PageCaptureService } from 'services/page-capture-service/page-capture.service';
import html2pdf from 'html2pdf.js';
import * as moment from 'moment';

export class ExtraOptionCheckbox {
  checked?: boolean;
  id?: string;
  name?: string;
}

export class PullupMenuData {
  id?: string;
  name?: string;
  shortName?: string;
  iconUrl?: string;
  data?: any;
  disabled?: boolean;
  cssClass?: string;
}

export class MessageData {
  title?: string;
  content?: string;
}
/***
 @param dataList - list of items to display in structure of
 * {
  id?: string;
  name?: string;
  shortName?: string;
  iconUrl?: string;
 * }
  @param headerTitle - string
  @param mode - default common | scoringCompetition | singleSelection | infoDisplay | dualOptions | messageSuccess
  @param selectedValue - string
  @param noTickIndivator - boolean - to hide tick indicator when value is selected
  *
  */
@Component({
  selector: 'app-common-pullup-menu',
  templateUrl: './common-pullup-menu.component.html',
  styleUrls: ['./common-pullup-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommonPullupMenuComponent implements OnInit {
  @Input() app: any;
  @Input() dataList: Array<PullupMenuData> = [];
  @Input() headerTitle: string = '';
  @Input() subTitle: string = '';
  @Input() mode = 'common';
  @Input() message: MessageData = {};
  @Input() showConfirmBtn = true;
  @Input() showCancelBtn = true;
  @Input() showCloseBtn = true;

  /**
   * dualOptions mode only: hides the redundant outline Close button above the
   * two action buttons. Defaults to true so all existing usages are unchanged.
   */
  @Input() showDualCloseBtn = true;

  @Input() header = 'Confirm';
  @Input() yesText = 'Yes';
  @Input() noText = 'No';
  @Input() confirmMessage = 'Are you sure you want to proceed ?';
  @Input() scorecard: PlainScoreCard | null = null;
  @Input() buggyNo: string = '';

  @Input() firstBtnTxt = '';
  @Input() secondBtnTxt = '';
  @Input() selectedValue = '';
  @Input() quickPlayerType = 'mygolf2u'; // mygolf2u || clubMember
  @Input() searchQuickPlayer = '';
  @Input() dataId: any = null;
  @Input() exclusionList: Array<any> = [];
  resultQuickPlayers: any = null;
  selectedItem: any = null;

  @Input() extraCheckboxOption: ExtraOptionCheckbox = {};
  @Input() membershipNo: string = '';
  @Input() inputRequired = false;

  @Input() competitionFeeApplicable: CompetitionFeeApplicable = {};
  @Input() competitionData: CompetitionData = {};

  @Input() mainBtnColor: string = '';
  @Input() playerMatch: CompetitionMatch = {};
  @Input() hideTickIndicator = false;
  @Input() compData: CompetitionData = {};
  @Input() flightScores: any = null;
  @Input() payableAmount = 0;
  @Input() closeBtnText = 'Close';
  @Input() firstBtnColor = '';
  @Input() secondBtnColor = 'secondary';
  @Input() showSearchbar: boolean = false;
  @Input() scrollable: boolean = false;
  @Input() multipleSelection: boolean = false;
  @Input() showPrintButton: boolean = true;
  @Input() selectedMultiValues: any[]; // number[] | string[];
  @Input() maxSelection: number = 0;

  constructor(
    private mdlCtrl: ModalController,
    private flightService: ClubFlightService,
    private mg2uUtils: mygolfUtils,
    private platform: Platform,
    private toastCtl: ToastController,
    private loadingController: LoadingController,
    private pageCaptureService: PageCaptureService
  ) {
    console.debug('init common pullup [0] : ', this.dataList);
  }

  ngOnInit() {
    console.debug('init common pullup [1] : ', this.dataList);
    console.debug('init common pullup [2] mode : ', this.mode);
    console.debug('init common pullup [3] message : ', this.message);
    console.debug('init common pullup [4] firstBtnTxt : ', this.firstBtnTxt);
    console.debug('init common pullup [5] secondBtnTxt : ', this.secondBtnTxt);
    console.debug(
      'init common pullup [6] selected multi values - multiple data : ',
      this.selectedMultiValues,
      this.multipleData,
      this.maxSelection
    );
    if (this.multipleSelection) this.hideTickIndicator = false;
    if (this.dataList?.length) {
      this.dataList?.forEach(dl => {
        if (dl?.iconUrl) {
          if (dl?.iconUrl?.toLowerCase()?.includes(global.MygolfServerHost?.toLowerCase())) {
          } else if (dl?.iconUrl?.toLowerCase()?.startsWith('assets')) {
          } else dl.iconUrl = global.MygolfServer + '/' + dl?.iconUrl;
        }
      });
    }
    if (this.selectedMultiValues?.length && this.dataList?.length) {
      this.dataList.forEach(data => {
        if (
          this.selectedMultiValues?.find(value => {
            return data?.id === value;
          })
        ) {
          this.multipleData.push(data);
        }
      });
    }
  }

  multipleData: any[] = [];
  onClick(data: PullupMenuData) {
    console.debug(
      'is selected data : ',
      this.multipleSelection,
      this.multipleData,
      this.selectedValue,
      data
    );
    if (data?.disabled !== undefined && data?.disabled) return;
    if (data?.id === this.selectedValue) return;
    if (this.multipleSelection) {
      let _multiData: any[] = this.mg2uUtils.getUnique(this.multipleData, 'id');
      if (
        _multiData?.filter(mpData => {
          return mpData?.id === data?.id;
        })?.length > 0
      ) {
        this.multipleData = _multiData.filter(mpData => mpData?.id !== data.id);
        console.debug('is selected data [1] : ', this.multipleData, _multiData);
      } else {
        if (this.maxSelection > 0 && this.multipleData?.length >= this.maxSelection) {
          MessageDisplayUtil.showMessageToast(
            `Max ${this.maxSelection} selection(s) have been reached`,
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          return;
        }
        this.multipleData.push(data);
        this.multipleData = this.mg2uUtils.getUnique(this.multipleData, 'id');
      }
    } else {
      this.mdlCtrl.dismiss(data);
    }
  }

  onClickCancel() {
    this.mdlCtrl.dismiss();
  }

  onClickConfirm() {
    this.mdlCtrl.dismiss(true);
  }

  onClickDual(type: any) {
    this.mdlCtrl.dismiss(type);
  }

  onClickApply() {
    if (this.mode === 'common' && this.multipleSelection) {
      return this.mdlCtrl.dismiss(this.multipleData);
    } else {
      if (!this.selectedItem) return;
      const _selectedData = this.dataList.find(item => {
        return item.id === this.selectedItem;
      });
      this.mdlCtrl.dismiss(_selectedData);
    }
  }

  subSearchQuickPlayer: Subscription | null = null;
  refresher = false;
  onClickSearchQuickPlayer() {
    if (this.subSearchQuickPlayer) return;
    if (!this.searchQuickPlayer) return;
    if (!this.dataId) return;
    // if(this.quickPlayerType === 'clubMember' && this.searchQuickPlayer.length < 3) return;
    this.refresher = true;
    const _searchBy = this.searchQuickPlayer?.toLowerCase();
    this.resultQuickPlayers = [];
    if (this.quickPlayerType === 'mygolf2u') {
      this.flightService.getPlayerById(Number(_searchBy)).subscribe(
        (player: PlayerData) => {
          if (player) {
            JsonService.deriveFulImageURL(player, 'profile');
            JsonService.deriveFulImageURL(player, 'image');
            this.resultQuickPlayers.push(player);
            if (this.exclusionList?.length) {
              this.resultQuickPlayers = this.mg2uUtils.filterExcludeExistingIds(
                this.resultQuickPlayers,
                this.exclusionList,
                'id'
              );
              // this.resultQuickPlayers = this.resultQuickPlayers.filter((p: PlayerData)=>{
              //   return p.id !==
              // })
            }
          }
          if (this.subSearchQuickPlayer) {
            this.subSearchQuickPlayer.unsubscribe();
            this.subSearchQuickPlayer = null;
          }
          this.refresher = false;
        },
        error => {
          if (this.subSearchQuickPlayer) {
            this.subSearchQuickPlayer.unsubscribe();
            this.subSearchQuickPlayer = null;
          }
          this.refresher = false;
        }
      );
    } else if (this.quickPlayerType === 'clubMember') {
      this.flightService.searchPlayerByMembership(_searchBy, this.dataId).subscribe(
        (players: Array<PlayerData>) => {
          if (players?.length) {
            // players.forEach((p: PlayerData)=>{
            //   JsonService.deriveFulImageURL(p, 'profile');
            //   JsonService.deriveFulImageURL(p, 'image');
            // })
            this.resultQuickPlayers = players.filter((p: PlayerData) => {
              return p.status === 'Active';
            });
            if (this.exclusionList?.length) {
              this.resultQuickPlayers = this.mg2uUtils.filterExcludeExistingIds(
                this.resultQuickPlayers,
                this.exclusionList,
                'id'
              );
              // this.resultQuickPlayers = this.resultQuickPlayers.filter((p: PlayerData)=>{
              //   return p.id !==
              // })
            }
          }

          if (this.subSearchQuickPlayer) {
            this.subSearchQuickPlayer.unsubscribe();
            this.subSearchQuickPlayer = null;
          }
          this.refresher = false;
        },
        error => {
          if (this.subSearchQuickPlayer) {
            this.subSearchQuickPlayer.unsubscribe();
            this.subSearchQuickPlayer = null;
          }
          this.refresher = false;
        }
      );
    }
  }

  getPlayerImage(player: PlayerData) {
    if (!player) return;
    // console.debug("get player image : ", player)
    if (player?.profile) return player?.profile;
    else if (player?.image) return player?.image;
    else return;
  }

  onChangeQuickPlayerType(event: any) {
    console.debug('change quick player type : ', this.quickPlayerType, event);
    this.searchQuickPlayer = '';
    this.resultQuickPlayers = [];
    // this.onClickSearchQuickPlayer();
  }

  onSelectQuickPlayer(player: any) {
    if (!player) return;
    const _selectedPlayer = [];
    // _selectedPlayer.push(player);

    var obj = {
      group: false,
      item: player,
      isCovid: true,
      newPlayer: false,
      playerDetails: player,
      playerContact: '',
      availableBalance: 0,
    };
    _selectedPlayer.push(obj);
    this.mdlCtrl.dismiss({
      playerList: _selectedPlayer,
    });
  }

  getFilteredExclusionList() {
    let _filtered = [];
    if (this.exclusionList?.length) {
      _filtered = this.exclusionList.filter((p: any) => {
        if (this.quickPlayerType === 'clubMember') {
          // console.debug("filter exclusion : ", p?.membership, p?.membership?.membershipNo, this.searchQuickPlayer)
          return p?.membership?.membershipNo.toLowerCase() === this.searchQuickPlayer.toLowerCase();
        } else {
          return p?.id === Number(this.searchQuickPlayer);
        }
      });
    }
    return _filtered;
  }

  onClickCompRegister(type: any) {
    console.debug('on click comp register', type, this.inputRequired, this.membershipNo);
    if (
      this.inputRequired &&
      this.extraCheckboxOption?.checked &&
      (this.membershipNo === undefined || this.membershipNo?.length === 0)
    ) {
      MessageDisplayUtil.showErrorToast(
        'Please enter membership number',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    this.mdlCtrl.dismiss({
      type: type,
      extraCheckboxOption: this.extraCheckboxOption,
      membershipNo: this.membershipNo,
    });
  }

  getAmountToPay() {
    const _currency = this.competitionFeeApplicable?.currencySymbol || '';
    let _amountToPay = 0;
    if (this.competitionFeeApplicable?.paymentStatus?.toLowerCase().includes('unpaid')) {
      if (this.payableAmount > 0) {
        _amountToPay = this.payableAmount;
      }
    } else {
      if (this.extraCheckboxOption?.checked) {
        _amountToPay = this.competitionData?.tournamentFeeClubMember || 0;
      } else if (this.competitionFeeApplicable?.applicableFee) {
        _amountToPay = this.competitionFeeApplicable?.applicableFee;
      } else {
        _amountToPay = this.competitionData?.tournamentFee || 0;
      }
    }

    return _currency + ' ' + _amountToPay;
  }

  @Input() textAlign = 'center';
  getTextAlign() {
    return this.textAlign;
  }
  backButtonSub: Subscription | null = null;
  ionViewWillEnter() {
    this.backButtonSub = this.platform.backButton.subscribeWithPriority(10000, () => {
      // MessageDisplayUtil.showMessageToast(
      //   'back button',
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'bottom'
      // );
      this.mdlCtrl.dismiss();
    });
  }

  ionViewWillLeave() {
    this.backButtonSub?.unsubscribe();
  }

  setMinHeight() {
    if (!this.scrollable) return '45vh';

    let _minHeight = 4; //in rem
    const dataLength = this.dataList?.length || 0;
    if (!dataLength) return '0rem;';
    if (dataLength < 5) {
      return `${dataLength * _minHeight}rem`;
    } else return '20rem';
  }

  filteredDataList() {
    let _filtered = this.dataList;
    const _searchText = this.searchText?.toLowerCase();
    if (_searchText?.length) {
      _filtered = _filtered?.filter(dl => {
        const dataName = dl?.name?.toLowerCase();
        // console.debug('filtered data list : ', dl, dataName, _searchText);
        return dataName?.includes(_searchText);
      });
    }
    return _filtered;
  }

  searchText: string = '';

  @ViewChild('captureArea', { read: ElementRef }) captureArea!: ElementRef;
  isCapturing: boolean = false;

  async captureAsImage(): Promise<void> {
    await this.performCapture('image');
  }

  async captureAsPdf(): Promise<void> {
    await this.performCapture('pdf');
  }

  private async performCapture(format: 'image' | 'pdf'): Promise<void> {
    if (this.isCapturing) return;

    this.isCapturing = true;
    const loading = await this.loadingController.create({
      message: format === 'image' ? 'Preparing screenshot...' : 'Preparing PDF...',
      spinner: 'crescent',
      duration: 5000,
    });

    await loading.present();

    const currentDateTime = moment().format('YYMMddHHmmss');
    let clonedElement: HTMLElement | null = null;

    try {
      const compInfoType = this.message?.title || '';
      const filename = `comp${compInfoType}_${currentDateTime}`;
      const element = this.captureArea?.nativeElement;

      if (!element) {
        throw new Error('Content area not found');
      }

      // Dismiss loading BEFORE capture to avoid capturing the loading dialog
      await loading.dismiss();

      // Wait for dismiss animation to complete and UI to settle
      await new Promise(resolve => setTimeout(resolve, 400));

      // CLONE APPROACH: Create a clone of the content for capture
      // This preserves the original modal appearance
      clonedElement = this.createCaptureClone(element);

      // Small delay to ensure clone is rendered
      await new Promise(resolve => setTimeout(resolve, 100));

      // Perform the capture on the clone
      const blob =
        format === 'image'
          ? await this.pageCaptureService.capturePageAsImage({
              element: clonedElement,
              filename,
              format: 'image',
              quality: 0.95,
              backgroundColor: '#ffffff',
              delay: 300,
            })
          : await this.pageCaptureService.capturePageAsPdf({
              element: clonedElement,
              filename,
              format: 'pdf',
              delay: 300,
            });

      if (blob) {
        await this.pageCaptureService.saveAndShare(blob, filename, format);
        const message =
          format === 'image' ? 'Screenshot captured successfully!' : 'PDF generated successfully!';
        await this.showToast(message, 'success');
      }
    } catch (error) {
      console.error('Capture error:', error);
      await this.showToast('Error capturing page. Please try again.', 'danger');
    } finally {
      // Clean up: Remove the cloned element
      // if (1) return;
      if (clonedElement && clonedElement.parentNode) {
        clonedElement.parentNode.removeChild(clonedElement);
      }

      // Ensure loading is dismissed in case of error
      try {
        await loading.dismiss();
      } catch (e) {
        // Loading already dismissed, ignore error
      }
      this.isCapturing = false;
    }
  }

  /**
   * Create a clone of the element for capture
   * This allows us to modify the clone without affecting the original modal
   */
  private createCaptureClone(element: HTMLElement): HTMLElement {
    // Clone the element and all its children
    const clone = element.cloneNode(true) as HTMLElement;

    // Position clone off-screen to make it invisible
    clone.style.position = 'absolute';
    clone.style.left = '0'; //-9999px';
    clone.style.top = '0';
    clone.style.width = `${element.scrollWidth}px`;
    clone.style.height = `${element.scrollHeight}px`;

    // Apply CSS overrides only to the clone
    this.applyCloneCssOverrides(clone);

    // Add to DOM temporarily
    document.body.appendChild(clone);

    return clone;
  }

  /**
   * Apply CSS overrides to a cloned element for capture
   * Only modifies the clone, not the original element
   */
  private applyCloneCssOverrides(clone: HTMLElement): void {
    // Override height constraints to show full scrollable content
    clone.style.overflow = 'visible';
    clone.style.overflowY = 'visible';
    clone.style.overflowX = 'visible';
    clone.style.maxHeight = 'none';
    clone.style.height = 'auto';

    // Recursively apply to all child elements that might have constraints
    const constrainedElements = clone.querySelectorAll<HTMLElement>(
      '[style*="max-height"], [style*="overflow"]'
    );
    constrainedElements.forEach(child => {
      child.style.maxHeight = 'none';
      child.style.overflow = 'visible';
      child.style.overflowY = 'visible';
      child.style.height = 'auto';
    });
  }

  private async showToast(message: string, color: string): Promise<void> {
    const toast = await this.toastCtl.create({
      message,
      duration: 3000,
      color,
      position: 'bottom',
    });
    await toast.present();
  }

  /**
   * Export page as PDF using browser's native print functionality.
   * This captures the entire page including scrollable content.
   */
  async exportAsPdfNative(): Promise<void> {
    if (this.isCapturing) return;

    this.isCapturing = true;
    const loading = await this.loadingController.create({
      message: 'Preparing PDF...',
      spinner: 'crescent',
    });

    await loading.present();

    try {
      // Dismiss loading before print dialog
      await loading.dismiss();
      await new Promise(resolve => setTimeout(resolve, 200));

      // Store original body styles
      const originalBodyOverflow = document.body.style.overflow;
      const originalBodyHeight = document.body.style.height;

      // Ensure page is fully visible for print
      document.body.style.overflow = 'visible';
      document.body.style.height = 'auto';

      // Use browser's native print (which can save as PDF)
      window.print();

      // Restore body styles after a short delay
      setTimeout(() => {
        document.body.style.overflow = originalBodyOverflow;
        document.body.style.height = originalBodyHeight;
      }, 1000);

      this.isCapturing = false;
    } catch (error) {
      console.error('Native PDF export error:', error);
      await this.showToast('Error exporting PDF. Please try again.', 'danger');
      this.isCapturing = false;
    }
  }

  /**
   * Export page as PDF using html2pdf.js library.
   * This library handles full-page HTML to PDF conversion better than manual capture.
   */
  async exportAsPdfWithLibrary(): Promise<void> {
    if (this.isCapturing) return;

    this.isCapturing = true;
    const loading = await this.loadingController.create({
      message: 'Generating PDF...',
      spinner: 'crescent',
    });

    await loading.present();

    try {
      const filename = `event-details-${new Date().getTime()}`;
      const element = this.captureArea?.nativeElement;
      if (!element) {
        throw new Error('Content area not found');
      }

      await loading.dismiss();
      await new Promise(resolve => setTimeout(resolve, 300));

      // For full-page capture, get the ion-content scroll element
      const ionContent = element.closest('ion-content');
      const scrollElement = ionContent ? (ionContent as any).scrollElement : null;
      const captureElement = scrollElement || element;

      const opt = {
        margin: [10, 10, 10, 10] as [number, number, number, number],
        filename: `${filename}.pdf`,
        image: {
          type: 'jpeg' as 'jpeg' | 'png' | 'webp',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          scrollY: 0,
          scrollX: 0,
          windowHeight: captureElement.scrollHeight,
          windowWidth: captureElement.scrollWidth,
        },
        jsPDF: {
          unit: 'mm' as 'mm' | 'cm' | 'in' | 'pt' | 'px' | 'pc',
          format: 'a4' as string,
          orientation: 'portrait' as 'portrait' | 'landscape',
        },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] as ('avoid-all' | 'css' | 'legacy')[] },
      } as any; // Cast to any to bypass strict type checking for html2pdf.js

      await html2pdf().set(opt).from(captureElement).save();

      await this.showToast('PDF generated successfully!', 'success');
    } catch (error) {
      console.error('html2pdf error:', error);
      await this.showToast('Error generating PDF. Please try again.', 'danger');
    } finally {
      this.isCapturing = false;
    }
  }

  /**
   * Enhanced scroll element detection that works in modal context
   * Traverses up DOM to find actual scrollable container
   */
  private findScrollElement(element: HTMLElement): HTMLElement | null {
    // First try to get the parent ion-content's scroll element
    const ionContent = element.closest('ion-content');
    if (ionContent) {
      const scrollElement = (ionContent as any).scrollElement;
      if (scrollElement) {
        return scrollElement;
      }
    }

    // If ion-content scrollElement not available, traverse up DOM to find scrollable element
    let currentElement: HTMLElement | null = element;

    while (currentElement) {
      // Check if this element has scrollable content
      const hasScrollableContent =
        currentElement.scrollHeight > currentElement.clientHeight ||
        currentElement.scrollWidth > currentElement.clientWidth;

      const hasVisibleOverflow =
        window.getComputedStyle(currentElement).overflow === 'auto' ||
        window.getComputedStyle(currentElement).overflow === 'scroll' ||
        window.getComputedStyle(currentElement).overflowY === 'auto' ||
        window.getComputedStyle(currentElement).overflowY === 'scroll' ||
        window.getComputedStyle(currentElement).overflowX === 'auto' ||
        window.getComputedStyle(currentElement).overflowX === 'scroll';

      if (hasScrollableContent && hasVisibleOverflow) {
        return currentElement;
      }

      // Move up to parent element
      currentElement = currentElement.parentElement;
    }

    // If no scrollable element found, try to get the ion-content element itself
    if (ionContent) {
      return ionContent as HTMLElement;
    }

    return null;
  }

  /**
   * Apply CSS overrides to remove height constraints during capture
   */
  private applyCssOverrides(
    element: HTMLElement,
    originalStyles: Map<HTMLElement, { [key: string]: string }>
  ): void {
    const styles = window.getComputedStyle(element);
    const currentStyles: { [key: string]: string } = {};

    // Store current styles
    ['max-height', 'min-height', 'height', 'overflow', 'overflow-y', 'overflow-x'].forEach(prop => {
      const value = styles.getPropertyValue(prop);
      if (value && value !== 'none' && value !== 'visible' && value !== 'auto') {
        currentStyles[prop] = value;
      }
    });

    if (Object.keys(currentStyles).length > 0) {
      originalStyles.set(element, currentStyles);
    }

    // Apply overrides
    element.style.setProperty('max-height', 'none', 'important');
    element.style.setProperty('min-height', 'auto', 'important');
    element.style.setProperty('height', 'auto', 'important');
    element.style.setProperty('overflow', 'visible', 'important');
    element.style.setProperty('overflow-y', 'visible', 'important');
    element.style.setProperty('overflow-x', 'visible', 'important');
  }

  /**
   * Apply CSS overrides to parent containers that might constrain height
   */
  private applyParentCssOverrides(
    element: HTMLElement,
    originalStyles: Map<HTMLElement, { [key: string]: string }>
  ): void {
    let currentElement: HTMLElement | null = element.parentElement;
    const maxLevels = 5; // Limit how many parent levels to check
    let level = 0;

    while (currentElement && level < maxLevels) {
      const styles = window.getComputedStyle(currentElement);
      const hasHeightConstraint =
        styles.getPropertyValue('max-height') !== 'none' ||
        styles.getPropertyValue('min-height') !== '0px' ||
        styles.getPropertyValue('height') !== 'auto';

      if (hasHeightConstraint) {
        this.applyCssOverrides(currentElement, originalStyles);
      }

      currentElement = currentElement.parentElement;
      level++;
    }
  }

  /**
   * Restore original styles after capture
   */
  private restoreOriginalStyles(originalStyles: Map<HTMLElement, { [key: string]: string }>): void {
    originalStyles.forEach((styles, element) => {
      Object.keys(styles).forEach(prop => {
        element.style.setProperty(prop, styles[prop], 'important');
      });

      // Remove any properties we added that weren't there originally
      ['max-height', 'min-height', 'height', 'overflow', 'overflow-y', 'overflow-x'].forEach(
        prop => {
          if (!styles.hasOwnProperty(prop)) {
            element.style.removeProperty(prop);
          }
        }
      );
    });

    originalStyles.clear();
  }

  isSelectedData(data: PullupMenuData) {
    // console.debug(
    //   'is selected ddata : ',
    //   this.multipleSelection,
    //   data,
    //   this.multipleData,
    //   this.multipleData?.find(mpData => {
    //     return mpData?.id === data?.id;
    //   })
    // );
    if (!this.multipleSelection) return false;
    if (!this.multipleData?.length) return false;
    return (
      this.multipleData?.filter(mpData => {
        return mpData?.id === data?.id;
      })?.length > 0
    );
  }

  isSelectedClass(data: PullupMenuData) {
    if (this.multipleSelection) {
      return this.isSelectedData(data) ? 'selected' : '';
    } else {
      return this.selectedValue === data.id ? 'selected' : '';
    }
  }
  async captureMoreOptions() {
    let _dataList = [
      {
        id: 'downloadPdf',
        name: 'Download as PDF',
        // iconUrl: 'assets/icons/golf-website.png',
      },
      {
        id: 'downloadImage',
        name: 'Download as Image',
        // iconUrl: 'assets/icons/book.png',
      },
    ];
    const modal = await this.mdlCtrl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        // headerTitle: 'More Options',
        // subTitle: this.leagueRounds ? this.leagueRounds[0].seasonName : '',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        switch (data?.data?.id) {
          case 'downloadPdf':
            this.captureAsPdf();
            break;
          case 'downloadImage':
            this.captureAsImage();
            break;
        }
      }
    });
  }
}
